import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'views/components/Layout';
import { Button } from 'views/components/General';
import styles from './style.module.scss';

export default class ConfirmModal extends Component {
  shouldComponentUpdate(nextProps) {
    if (!this.props.open && !nextProps.open) return false;
    return true;
  }

  renderTitle = () => {
    if (this.props.destructive) {
      return <span className={styles['destructive-title']}>{this.props.title}</span>;
    } else {
      return this.props.title;
    }
  };

  render() {
    const primaryButtonLabel = this.props.confirmButtonText || 'general.ok';

    return (
      <Modal isOpen={this.props.open} width={420}>
        <Modal.Header title={this.renderTitle()} hideCloseButton />
        <Modal.Content>
          <div className={styles['content']}>{this.props.message}</div>
        </Modal.Content>
        <Modal.Footer>
          <Button.Group>
            <Button
              primary
              destructive={this.props.destructive}
              label={primaryButtonLabel}
              loading={this.props.confirmIsLoading}
              onClick={this.props.onConfirm}
            />
            <Button label="general.cancel" onClick={this.props.onCancel} />
          </Button.Group>
        </Modal.Footer>
      </Modal>
    );
  }
}

ConfirmModal.propTypes = {
  title: PropTypes.element,
  subtitle: PropTypes.element,
  destructive: PropTypes.bool,
  loading: PropTypes.bool,
  onOk: PropTypes.func,
  onClose: PropTypes.func,
};

ConfirmModal.defaultProps = {
  destructive: false,
  loading: false,
  onOk: () => null,
  onClose: () => null,
};
